import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GxBadgeComponent } from './gx-badge.component';

@NgModule({
  declarations: [GxBadgeComponent],
  imports: [
    CommonModule
  ],
  exports: [GxBadgeComponent]
})
export class GxBadgeModule { }
